import React, {useState, useEffect} from "react";

// MUI COMPONENTS
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MuiButton from "@mui/material/Button";

// COMPONENTS
import ContentBox from "@components/ContentBox/ContentBox";

// HELPERS
import api from "@helpers/api";
import {createClassName} from "@helpers/utils";
import ActivityIndicator from "../../../../../components/ActivityIndicator/ActivityIndicator.jsx";

const SectionSummaryIntro = props =>
{
	const [loaded, setLoaded] = useState(false);
	const [downloading, setDownloading] = useState(false);

	const downloadSummary = async () =>
	{
		if (downloading)
		{
			return false;
		}

		setDownloading(true);
		console.log("Downloading summary...");

		const rawDataInBase64 = await api(
			"/case/downloadDocument",
			{
				caseId,
				template: isCompany ? "documents/delsummering/company.pdf" : "documents/delsummering/person.pdf",
				docType: "document",
				frontpage: "documents/frontpage.pdf",
				attachment: null
			},
			{responseType: "arraybuffer"},
			true
		);

		if (rawDataInBase64 !== "")
		{
			const file = new Blob([rawDataInBase64], {type: "application/pdf"});
			const fileURL = URL.createObjectURL(file);
			const link = document.createElement("a");

			let today = new Date();
			link.href = fileURL;
			link.download = "Delsummering " + today.toISOString().split('T')[0] + ".pdf";
			link.click();
		}
		else
		{
			console.log("Could not download case data");
		}
		setDownloading(false);
	};

	useEffect(() =>
	{
		const {setAppState} = props;

		if (!loaded)
		{
			setAppState({
				viewFulfilled: true,
				showValidationWarning: false
			});
			setLoaded(true);
		}
	}, [props]);

	const {caseId, isCompany} = props.customer;
	const classes = createClassName("Cob-view", {});

	return (
		<div className={classes}>
			<ContentBox>
				<h2>Delsummering</h2>

				<Box sx={{
					width: "100%",
					display: "flex",
					flexDirection: "column",
					justifyContent: "flex-start",
					alignItems: "flex-start",
					mb: 2
				}}>
					<Box sx={{mb: 2}}>
						<Typography variant="subtitle1" color="primary.dark">
							Ladda ner en PDF med sammanfattning av alla besvarade frågor hittills för denna session.
						</Typography>
					</Box>
					<MuiButton
						id="fade-button"
						variant="contained"
						onClick={downloadSummary}
						sx={{
							backgroundColor: "button.main",
							flexDirection: "row",
							boxShadow: "none",
							height: "32px",
							width: "140px",
							justifyContent: "center",
							"&:hover": {
								backgroundColor: "button.main",
								filter: "brightness(105%)",
								boxShadow: "none"
							}
						}}>
						{downloading ?
							(
								<ActivityIndicator scale={0.4} busy/>
							)
							:
							(
								<Typography
									variant="button"
									sx={{
										fontSize: "12px",
										fontWeight: 400,
										textTransform: "uppercase",
										textDecoration: "none"
									}}>
									Ladda ner PDF
								</Typography>
							)
						}
					</MuiButton>
				</Box>
			</ContentBox>
		</div>
	);
};

export default SectionSummaryIntro;